import { render, staticRenderFns } from "./MemberDetails.vue?vue&type=template&id=6d550232&scoped=true"
import script from "./MemberDetails.vue?vue&type=script&lang=ts"
export * from "./MemberDetails.vue?vue&type=script&lang=ts"
import style0 from "./MemberDetails.vue?vue&type=style&index=0&id=6d550232&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d550232",
  null
  
)

export default component.exports